import { render, staticRenderFns } from "./AddQualification.vue?vue&type=template&id=ca3117fe"
import script from "./AddQualification.vue?vue&type=script&lang=js"
export * from "./AddQualification.vue?vue&type=script&lang=js"
import style0 from "./AddQualification.vue?vue&type=style&index=0&id=ca3117fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports